exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input{\r\n    font-size: 11px;\r\n    width: 100%;\r\n    \r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/playitadmin_frontend/src/app/add-product/add-product.component.css
// module id = ../../../../../src/app/add-product/add-product.component.css
// module chunks = main